// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"2631f137","245":"84bb65e1","395":"7c00ffbe","467":"6644943e","606":"7305be91","869":"41209665","954":"68cf840c","993":"d4f8549b"}[chunkId] + ".chunk.js";
};